import React, { useEffect } from "react";
import { connect } from "react-redux";
import { fetchInvoices } from "../../processes/invoicesProcesses";
import InvoicesList from "./InvoicesList";

function InvoicesListContainer(props) {
  const { dispatch } = props;

  useEffect(() => {
    fetchInvoices(dispatch);
  }, [dispatch]);

  return <InvoicesList {...props} />;
}

function mapStateToProps(state) {
  return {
    loading: state.invoicesList.loading,
    invoices: state.invoicesList.invoices,
  };
}

export default connect(mapStateToProps)(InvoicesListContainer);
